import { render } from "./newEnrolmentClass.vue?vue&type=template&id=ed1d2196&scoped=true"
import script from "./newEnrolmentClass.vue?vue&type=script&lang=js"
export * from "./newEnrolmentClass.vue?vue&type=script&lang=js"

import "./newEnrolmentClass.vue?vue&type=style&index=0&id=ed1d2196&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed1d2196"]])

export default __exports__